import {
    useLayoutEffect,
    useEffect,
    useState
} from "react";
import {
    TouchableOpacity,
    ActivityIndicator,
    ScrollView,
    View
} from "react-native";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    PageContainer,
    Text
} from "ncore-ui-kit";
import {
    useNavigation,
} from "@react-navigation/native";
import {
    useSafeAreaInsets
} from "react-native-safe-area-context";
import type {
    BoardOfDirectorsData
} from "../../../services/restAPI/actions/getBoardOfDirectors/types";
import type AppStackParamList from "../../../types/navigation/app";
import type {
    NativeStackNavigationProp
} from "@react-navigation/native-stack";
import {
    ChevronLeft
} from "lucide-react-native";
import {
    RESTService
} from "../../../services/restAPI";
import {
    BoardOfDirectorsCard
} from "../../../components";

const BoardDirectors = () => {
    const navigation = useNavigation<NativeStackNavigationProp<AppStackParamList>>();

    const {
        spaces,
        colors
    } = NCoreUIKitTheme.useContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const [data,
        setData] = useState<BoardOfDirectorsData[]>();
    const [loading,
        setLoading] = useState(true);

    const inset = useSafeAreaInsets();

    useLayoutEffect(() => {
        navigation.setOptions({
            headerShown: true,
            header: () => <View
                style={[
                    stylesheet.headerContainer,
                    {
                        backgroundColor: colors.content.container.default,
                        paddingHorizontal: spaces.spacingMd,
                        paddingTop: inset.top
                    }
                ]}
            >
                <TouchableOpacity
                    style={[
                        stylesheet.backButton,
                        {
                            padding: spaces.spacingSm
                        }
                    ]}
                    onPress={() => {
                        navigation.goBack();
                    }}
                >
                    <ChevronLeft
                        size={30}
                    />
                </TouchableOpacity>
                <View
                    pointerEvents="none"
                    style={[
                        stylesheet.headerTitleContainer,
                        {
                            top: inset.top + spaces.spacingSm
                        }
                    ]}
                >
                    <Text
                        variant="titleLargeSize"
                        color="high"
                        style={stylesheet.headerTitle}
                    >
                        {localize("board-of-directors")}
                    </Text>
                </View>
            </View>
        });
    }, [navigation]);

    useEffect(() => {
        getBoardOfDirectors();
    }, []);

    const getBoardOfDirectors = () => {
        RESTService.action("GetBoardOfDirectors", null)
            .then((res) => {
                if(res.code === 200 || res.code === 201 || res.code === 202) {
                    setData(res.payload);
                }
                setLoading(false);
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                setLoading(false);
            });
    };

    const renderBoardOfDirectors = () => {
        if (!data) return null;

        const president = data.find(item => item.isPresident);
        const members = data.filter(item => !item.isPresident);

        return <View
            style={stylesheet.container}
        >
            {president && (
                <View>
                    <BoardOfDirectorsCard
                        fullName={president.fullName}
                        position={president.positiom}
                        isPresident={president.isPresident}
                        profilePhotoURL={president.profilePhotoURL}
                    />
                </View>)}
            <View
                style={stylesheet.contentContainer}
            >
                {members.map((item, index) => <View
                    key={index}
                >
                    <BoardOfDirectorsCard
                        fullName={item.fullName}
                        position={item.positiom}
                        isPresident={item.isPresident}
                        profilePhotoURL={item.profilePhotoURL}
                    />
                </View>)}
            </View>
        </View>;
    };

    if(loading) {
        return <PageContainer
            style={stylesheet.loadingContainer}
        >
            <ActivityIndicator
                size={40}
                color={colors.content.icon.default}
            />
        </PageContainer>;
    }

    return <PageContainer
        isScrollable={false}
        style={stylesheet.container}
        backgroundColor="subtle"
    >
        <ScrollView
            style={stylesheet.scrollView}
            showsVerticalScrollIndicator={false}
            showsHorizontalScrollIndicator={false}
        >
            {renderBoardOfDirectors()}
        </ScrollView>
    </PageContainer>;
};
export default BoardDirectors;
